import { render, staticRenderFns } from "./DetalhesPropostas.vue?vue&type=template&id=9002edf0&scoped=true&"
import script from "./DetalhesPropostas.vue?vue&type=script&lang=js&"
export * from "./DetalhesPropostas.vue?vue&type=script&lang=js&"
import style0 from "./DetalhesPropostas.vue?vue&type=style&index=0&id=9002edf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9002edf0",
  null
  
)

export default component.exports